<!-- <form [formGroup]="form" class="row">
     <div class="col-6">
        <mat-form-field  appearance="outline" >
            <mat-label>Titular emisor de la carta</mat-label>
            <input formControlName="titularEmisorCarta"  matInput>
          </mat-form-field>
     </div>
     <div class="col-6">
         <mat-form-field  appearance="outline" >
            <mat-label>Firmas del Titular</mat-label>
            <input formControlName="firma"  matInput>
          </mat-form-field>
    </div>
</form> -->
<form [formGroup]="form" class="row">
    <!-- <div class="style-input-default" data-text="Accion autorizada *" [ngClass]="{error: verificateInput('nombre_empresa')}"> -->
      <!-- <input type="text" placeholder="Accion autorizada" formControlName="accion_autorizada"> -->
     
     <div class="col-12 texCenter">
         <!-- <p class="inputRadio">Verificación</p> -->
        <mat-radio-group class="checleft" formControlName="verificacion" aria-label="Select an option">
            <mat-radio-button class="marginRight" value="preventiva">Verificación Preventiva</mat-radio-button>
            <mat-radio-button class="marginLeft"  value="oferta">Verificación Oferta de Servicio</mat-radio-button>
          </mat-radio-group>
     </div>
     <div class="col-12 separador"></div>
     <div class="col-12">
        <mat-form-field class="col-6" appearance="outline" >
           <mat-label>Nombres y Apellidos del Candidato</mat-label>
           <input formControlName="nombre"  matInput>
         </mat-form-field>
         <mat-form-field class="col-6" appearance="outline" >
            <mat-label>C.I del Candidato</mat-label>
            <input ciRif formControlName="ci"  matInput>
          </mat-form-field>
          <mat-form-field class="col-6" appearance="outline" >
            <mat-label>Cargo Candidato</mat-label>
            <input formControlName="cargo"  matInput>
          </mat-form-field>
   </div>
   
    <div class=" col-12 flex">
      <div class="opcionCheck ">
        <p class="texto">Oferta Servicio</p>
        <mat-checkbox formControlName="oferta_servicio" ></mat-checkbox>
      </div>
      <div class="opcionCheck ">
        <p class="texto">Referencias Laborales</p>
        <mat-checkbox formControlName="referencias" ></mat-checkbox>
      </div>
      <div class="opcionCheck ">
        <p class="texto">Soporte de Titulos</p>
        <mat-checkbox formControlName="soporte" ></mat-checkbox>
      </div>
     </div>
    <!-- <div class="divSelector">
        <p class="inputRadio">Telefonos</p>
       <mat-radio-group class="checleft" formControlName="telefonos" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="divSelector">
        <p class="inputRadio">Número de Cuenta</p>
       <mat-radio-group class="checleft" formControlName="cuenta" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
   <div class="divSelector">
        <p class="inputRadio">Contenido del Correo de la Solicitud</p>
       <mat-radio-group class="checleft" formControlName="contenidoCorreo" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="divSelector">
        <p class="inputRadio">Monto/Saldo Disponible</p>
       <mat-radio-group class="checleft" formControlName="monto" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
  <div class="divSelector">
        <p class="inputRadio">Firmas del Titular</p>
       <mat-radio-group class="checleft" formControlName="firma" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
  -->
  </form>
  